import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Sidebar from '../components/Sidebar';
import Filter from '../components/FilterBookmark';
import FeedMore from '../components/FeedMore';
import Bookmarks from '../components/Bookmarks';
import * as Actions from '../models/feeds/actions';
import Store from '../library/M2Store';

class BookmarkController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dark_mode: (Store.get('m2darkmode') && Store.get('m2darkmode') == 'dark') ? true : false,
            more: {},
            items: [],
            show_more: false,
            filter: {}
        };
        this.intervalReload = 0;
    }



    __setDarkMode(event) {
        event.preventDefault();
        let dark_mode = !this.state.dark_mode;
        if(dark_mode) {
            Store.set('m2darkmode', 'dark');
        } else {
            Store.remove('m2darkmode');
        }
        this.setState({dark_mode: dark_mode});
    }

    onSearch(filter) {
       this.setState({items: [], filter: filter});
       this.props.actions.loadBookmarks(filter);
    }

    hideMoreItem() {
        this.setState({more: '', show_more: false});
    }

    componentDidMount() {
        this.props.actions.loadBookmarks(this.state.filter);

    }

    __repalceAll(string, search, to) {
        if(!string) return '';
        var target = string;
        return target.replace(new RegExp(search, 'g'), to);
    }

    __highlightObjectField(object, field, string) {


        if(object[field]) {
            let reg = new RegExp(string, "ig");
            let matches = object[field].match(reg);
            if(matches && matches.length > 0) {
                let unique_matches = matches.filter((v, i, a) => a.indexOf(v) === i);
                for (var i in unique_matches) {
                    object[field] = this.__repalceAll(object[field], unique_matches[i], '<span class="m2hlight">' + unique_matches[i] + '</span>');
                }
                return object[field];
            }
        }
        return object[field];
    }


    componentWillReceiveProps(p) {
        if(p.answer && p.answer.state) {
            switch(p.answer.state) {
                case 'ERROR_LOAD_BOOKMARKS':
                    alert('Ошибка загрузки избранного');
                break;
                case 'FINISH_LOAD_BOOKMARKS':
                    if(p.answer.data.result == 'success') {
                        if(this.state.filter && this.state.filter.search) {
                            let items = p.answer.data.items;
                            if(items && items.length > 0) {
                                for(var i in items) {
                                    items[i].title = this.__highlightObjectField(items[i], 'title', this.state.filter.search);
                                    items[i].anons = this.__highlightObjectField(items[i], 'anons', this.state.filter.search);
                                    items[i].description = this.__highlightObjectField(items[i], 'description', this.state.filter.search);
                                }
                            }
                            this.setState({items: items});
                        } else {
                            this.setState({items: p.answer.data.items});
                        }

                    } else {
                        alert('Ошибка загрузки избранного');
                    }
                break;
            }
        }
    }

    showMore(item) {
        this.setState({more: item, show_more: true});
    }

    removeBookmarks(items) {
        this.props.actions.removeBookmarks(items);


        let state_items = this.state.items;
        let result_items = [];

        state_items.map(function(item) {
            if(items.indexOf(item.id) + 1 == 0) {
               result_items.push(item);
            }
        });

        this.setState({items: result_items});

    }


    render() {
        let className = ['m2controller', 'm2controller__feed'], loading = false;
        let svg_logo = '<use xlink:href="#icon-logo"></use>';
        if(this.state.dark_mode) {
            className.push('m2dark_mode');
        }

        if(this.props.answer) {
            if(this.props.answer.state == 'START_LOAD_BOOKMARKS') {
                loading = true;
            }
        }



        let feedListClasses = ['m2content__feeds_list'],showMoreClassNames = ['m2content__feed_more'];
        if(loading) {
            feedListClasses.push('m2loader_feed');
        }

        if(this.state.show_more) {
            showMoreClassNames.push('visible');
        }

        return (
            <div className={className.join(' ')}>
                <div className="m2sidebar">
                    <Sidebar darkmode={this.__setDarkMode.bind(this)}/>
                </div>
                <div className="m2content">
                    <div className="m2content__header">
                        <div className="header__logo">
                            <svg width="145px" height="43px" dangerouslySetInnerHTML={{__html: svg_logo}}></svg>
                        </div>
                        <div className="header__filter">
                            <Filter onSearch={this.onSearch.bind(this)}/>
                        </div>
                    </div>
                    <div className="m2content__container m2feeds_container m2feed_bookmark">
                       <div className="m2content__feeds_list">
                           <Bookmarks remove={this.removeBookmarks.bind(this)} more={this.showMore.bind(this)} items={this.state.items} />
                       </div>
                       <div className={showMoreClassNames.join(' ')}>
                           <FeedMore hideMore={this.hideMoreItem.bind(this)} {...this.state.more}/>
                       </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    answer: state.FeedReducer
});
const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchProps
)(BookmarkController);



// WEBPACK FOOTER //
// ./src/controllers/BookmarkController.js